import { WEB_URL_ACTIONS } from 'constants/liveCommerceConstants/webUrl';

const initialState = {
  pending: true,
  liveCommerce: null,
  error: {},
};

export const webUrl = (state = initialState, action) => {
  switch (action.type) {
    case WEB_URL_ACTIONS.PENDING:
      return initialState;

    case WEB_URL_ACTIONS.REJECTED:
      return { ...state, pending: false, error: action.error };

    case WEB_URL_ACTIONS.FULFILLED:
      if(action.response.results && action.response.results.length > 0) {
        const { name, is_active, config: { web_url } } = action.response.results[0];
        return {
          ...state,
          pending: false,
          liveCommerce: {
            name: name.toUpperCase(),
            isActive: is_active,
            url: `${web_url}/redirect/instore/{lc-token}`,
          },
          error: {},
        };
      }
      return state;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/liveCommerceReducers/webUrl.js